import axios from "axios"
import { constructURL } from "../util/CommonMethods"
import { acquireToken } from "../auth/authService"

class AxiosOperations {
  private baseUrl: string = import.meta.env.VITE_APP_BASE_URL

  private axiosInstance = axios.create({
    baseURL: this.baseUrl,
  })

  constructor() {
    // Add a request interceptor
    this.axiosInstance.interceptors.request.use(
      async (config) => {
        const token = await acquireToken()
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
        return config
      },
      (error) => {
        // Do something with request error
        return Promise.reject(error)
      },
    )
  }

  async get(api: string, params: any = {}) {
    const url = constructURL(api, params)
    const response = await this.axiosInstance.get(url)
    return response.data
  }

  async post(api: string, payload: any = {}) {
    const response = await this.axiosInstance.post(api, payload)
    return response.data
  }

  async delete(api: string, params: any = {}) {
    const url = constructURL(api, params)
    const response = await this.axiosInstance.delete(url)
    return response.data
  }

  async postWithQueryParams(api: string, formData: any = {}) {
    const response = await this.axiosInstance.post(api, formData)
    return response.data
  }
}

export default AxiosOperations
